export default __webpack_public_path__ + "assets/doc.0408.svg";